import loadable from '@loadable/component';

export const ReportButton = loadable(
  () => import(/* webpackChunkName: "extra" */ './report-button')
);
